import { Route, Routes } from "react-router-dom";
import { AuthProvider } from "@/auth/AuthContext";
import { RequireAdmin, RequireAuth } from "@/components/Guards";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import LoginPage from "@/pages/LoginPage";
import VideosPage from "@/pages/VideosPage";
import WatchPage from "@/pages/WatchPage";
import CheckinsPage from "@/pages/CheckinsPage";
import AdminPage from "@/pages/AdminPage";
import AdminUsersTab from "@/pages/admin/UsersTab";
import AdminCategoriesTab from "@/pages/admin/CategoriesTab";
import AdminVideosTab from "@/pages/admin/VideosTab";
import AdminVodImportTab from "@/pages/admin/VodImportTab";
import AdminCheckinsTab from "@/pages/admin/CheckinsTab";

export default function App() {
  return (
    <AuthProvider>
      <div className="flex min-h-screen flex-col">
        <Header />
        <div className="flex-1">
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/" element={<RequireAuth><VideosPage /></RequireAuth>} />
            <Route path="/watch/:id" element={<RequireAuth><WatchPage /></RequireAuth>} />
            <Route path="/checkins" element={<RequireAuth><CheckinsPage /></RequireAuth>} />
            <Route path="/admin" element={<RequireAdmin><AdminPage /></RequireAdmin>}>
              <Route index element={<AdminUsersTab />} />
              <Route path="categories" element={<AdminCategoriesTab />} />
              <Route path="videos" element={<AdminVideosTab />} />
              <Route path="checkins" element={<AdminCheckinsTab />} />
              <Route path="vod-import" element={<AdminVodImportTab />} />
            </Route>
          </Routes>
        </div>
        <Footer />
      </div>
    </AuthProvider>
  );
}
